/*
 * @Author: your name
 * @Date: 2021-04-22 10:49:42
 * @LastEditTime: 2023-05-09 14:07:04
 * @LastEditors: wuchengcheng
 * @Description: In User Settings Edit
 * @FilePath: /web-platform/src/store/modules/system.js
 */

import { getUnreadMessageApi } from '@/api/notice'
const state = {
  notifyNumber: 0,
  // 客服电话
  consumerHotline: '400-8566-100',
  isIE: !!window.ActiveXObject || 'ActiveXObject' in window,

  // 侧边菜单栏是否收起
  isSideCollapse: sessionStorage.getItem('sidebarStatus')
    ? !!+sessionStorage.getItem('sidebarStatus')
    : false,
  isGuoMi: false
}

const mutations = {
  SET_UNREAD_NUMBER: (state, number) => {
    state.notifyNumber = number
  },

  SET_SIDE_COLLAPSE: (state, data) => {
    state.isSideCollapse = data
  }
}

const actions = {
  getUnreadNotifyNumber({ commit, state }, params = {}) {
    return new Promise((resolve, reject) => {
      getUnreadMessageApi(params)
        .then(res => {
          const count = res.data?.count || 0
          commit('SET_UNREAD_NUMBER', count)
          resolve(count)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  setSideCollapse({ commit, state }, data) {
    commit('SET_SIDE_COLLAPSE', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
